import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./about.css";
// import Profile1 from "../../assets/img/profile/profile.webp";
import Profile from "../../assets/img/profile/yash.jpg";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

const About = () => {
  return (
    <div id="about">
      <div className="about">
        <h4 className="pt-3 text-center font-details pb-3 title">ABOUT ME</h4>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6}>
              <Row className="justify-content-center mb-2  ">
                <Image
                  className="profile justify-content-end"
                  alt="profile"
                  src={Profile}
                  thumbnail
                  fluid
                />
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row className="my-details ">
                <div style={{ textAlign: "center" }}>
                  {" "}
                  <h3 style={{ textAlign: "center" }}>
                    Hi there! I am{" "}
                    <span style={{ color: "crimson" }}>Yash Verma </span>{" "}
                  </h3>
                </div>
                <div className="myfolio">
                  {" "}
                  <p class="pg">
                    A passionate programmer , born and brought up in India. I am
                    a Full Stack Web Developer with React.js, Redux, Express.js,
                    Node.js, and PostgreSQL as my tech stack. In 2021,
                    Isuccessfully completed my Engineering with specialization
                    in 'Computer Science'. Working with the clients, my goal is
                    always driven towards providing amazing experience with the
                    best level of quality and service to them. Along with that,
                    I also help people as a Guider on their journey of becoming
                    a professional programmer. I love learning about new
                    technologies, what problems are they solving and How can I
                    use them to build better and scalable products.
                  </p>
                </div>
                <br /> <br />
                <Col className="d-flex justify-content-center flex-wrap">
                  <div style={{ marginTop: "0.3rem" }}>
                    <a
                      href="https://drive.google.com/file/d/1Snbq3x4Itk_ZN4c8J96aNdp4SunXR08Y/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button
                        style={{ fontWeight: 700 }}
                        className="m-2"
                        variant="outline-danger"
                      >
                        Download CV
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
